var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Reset all data")]),_vm._v(" "),_c('p',[_vm._v("WARNING: Clicking the button below will delete all data associated with the cover calculator (this action is not reversible)")]),_vm._v(" "),_c('button',{staticClass:"submit-button",on:{"click":_vm.submit}},[_vm._v("Reset Plugin")]),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"error",domProps:{"innerHTML":_vm._s(_vm.error)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41dd6cf8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Reset.vue
// module id = 133
// module chunks = 0